<template>
  <!-- template里只能有一个根节点 -->
  <div class="demo-page">
    <div><label  class="title">"古诗词大作战"</label></div>
    <!-- 点击跳转详情页 -->
    <div><input class="btn" type="button" value="开始" @click="golist" /></div>
    <div><input class="btn" type="button" value="重置" @click="restart" /></div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .demo-page {
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .title {
    font-size: 40px;
    text-align: center;
  }

  .btn {
    width: 550px;
    height: 86px;
    margin-top: 75px;
    border-radius: 43px;
    background-color: #09ba07;
    font-size: 30px;
    color: #ffffff;
  }
</style>



<script>
  import storage from './storage.js'
  export default {
    name: 'HelloWorld',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },

    methods : {
      golist() {//方法，定义路由跳转，注意这里必须使用this，不然报错
        var _this = this;
        _this.$router.push({path: "/user/20"});
      },

      routeDetail() {
        // 跳转到应用内的某个页面，router用法详见：文档->接口->页面路由
        this.$route.router.push({
          uri: '/user'
          //uri: '/List'
        })
      },
      restart:function () {
        storage.setItem('gold',30)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?4c90f2a2